import React from 'react';
import { InstallButton as NavigationInstallButton } from '@studio/legacy-navigation';
import { Link } from 'react-router-dom';

const InstallButton = () => <NavigationInstallButton Link={Link} />;

export default InstallButton;
